<template>
  <a-spin
    tip="Your document is being processed, do not leave this page!"
    :spinning="loading.page"
  >
    <a-card>
    <span slot="title" class="m-text-title">Rekapitulasi Realisasi Tarif Lembur</span>
    <a-tabs
        class="custom-tabs"
        :activeKey="tabActive"
        @change="handleTab"
    >
        <a-tab-pane key="list">
        <template slot="tab">
            <span>Daftar Realisasi Tarif Lembur</span>
            <a-badge
            v-if="this.listData.length > 0"
            class="m-badge m-badge-small"
            :count="this.listData.length"
            :numberStyle="{ backgroundColor: 'red' }"
            >
            </a-badge>
        </template>
        <a-input-search placeholder="Pencarian" v-model="search" @change="onChangeSearch" 
            class="textsearch" :loading="loading.search"></a-input-search>

        <a-table
          :rowKey="(record, index) => { return index.toString(); }"
          size="small"
          bordered
          :scroll="{ x: 850 }"
          :columns="columns"
          :dataSource="listDataSearch"
          :loading="loading.tab"
          :pagination="pagination"
          :rowClassName="(record, index) => { return record.check == true ? 'selectedRow' : '' }"
        >
          <template slot="nomor" slot-scope="text,item,index">{{index+1}}</template>
          <template slot="create_date_and_tlc" slot-scope="item">
            <div style="display: flex; flex-direction: column;">
              <span>{{ dateFormat(item.create_dt) }}</span>
              <span>{{ item.tlc_create }}</span>
            </div>
          </template>
          <template slot="no_realisasi_spl" slot-scope="item">{{ item.no_realisasi_spl }}</template>
          <template slot="divisi" slot-scope="item">{{ item.divisi }}</template>
          <template slot="pelaksana" slot-scope="item">{{ item.pelaksana }}</template>
          <template slot="total_tarif" slot-scope="item">{{ formatDecimal(item.total_tarif) }}</template>

          <div slot="customTitle">
            Aksi
            <a-checkbox
              style="padding-left:10px"
              :checked="isAllChecked"
              :indeterminate="isIndeterminate"
              @change="onSelectAll"
            />
          </div>
          <template slot="aksi1" slot-scope="item">
            <a-button icon="eye" size="small" type="primary" @click="showModalView(item)"></a-button>
          </template>
          <template slot="aksi2" slot-scope="item" >
            <a-checkbox
              :id="item.idx"
              v-model="item.check"
              @change="onSelectedItem"
            />
          </template>
          <div slot="footer" class="m-text-right">
            <a-button type="primary" @click="showRekapModal" >Rekap</a-button>
          </div>
        </a-table>

        </a-tab-pane>
        <a-tab-pane key="rekap_realisasi">
          <template slot="tab">
              <span>Rekap Realisasi Tarif Lembur</span>
          </template>
          <a-input-search placeholder="Pencarian" v-model="search" @change="onChangeSearch" 
              class="textsearch" :loading="loading.search"></a-input-search>

          <a-table
            :rowKey="(record, index) => { return index.toString(); }"
            size="small"
            bordered
            :scroll="{ x: 850 }"
            :columns="columns_recap"
            :dataSource="listRekap"
            :loading="loading.tab"
            :pagination="pagination"
            :rowClassName="(record, index) => { return record.check == true ? 'selectedRow' : '' }"
          >
            <template slot="nomor" slot-scope="text,item,index">{{index+1}}</template>
            <template slot="no_rekap_tarip" slot-scope="item">{{ item.no_rekap_tarip }}</template>
            <template slot="create_dt" slot-scope="item">{{ dateFormat(item.create_dt) }}</template>
            <template slot="tlc_create" slot-scope="item">{{ item.tlc_create }}</template>
            <template slot="periode" slot-scope="item">{{ formatPeriode(item.periode_rekap) }}</template>
            <template slot="catatan" slot-scope="item">{{ item.catatan }}</template>
            <template slot="action" slot-scope="item">
              <div class="action-section">
                <a-button icon="eye" size="small" type="primary" @click="showManifest(item)"></a-button>
                <a-button icon="delete" :disabled="item.status == 'Approved'" size="small" type="danger" @click="showConfirm(item)"></a-button>
              </div>
            </template>
          </a-table>
        </a-tab-pane>
    </a-tabs>
    </a-card>

    <a-modal
      v-model="modalVisible"
      v-if="modalVisible"
      :title="`Detail Realisasi Lembur: ${labelNo}`"
      :maskClosable="false"
      @cancel="modalClose"
      :width="900"
      >
      <a-card class="d-flex flex-column nowrap">
        <a-list :grid="{ gutter: 16, lg: 1 }" :dataSource="detailData" :pagination="pagination" :loading="loading.detail">
          <a-list-item slot="renderItem" slot-scope="item, index">
            <a-card hoverable class="d-flex flex-column nowrap">
              <a-list-item-meta>
                <ul slot="description" class="list-wrapper">
                  <table style="width:100%">
                    <tr >
                      <td>
                        <a-row :gutter="16">
                          <a-col :xs="24" :lg="3">
                            <div :class="isMobile ? 'head-dtl-lembur' :''" style="width:100%">
                            <a-avatar
                            :size="isMobile? 24 : 52"
                            :class="isMobile ? 'avatar-dtl-lembur' : ''"
                            >{{ index + 1 }}</a-avatar>
                            </div>
                          </a-col>
                          <a-col :xs="24" :lg="12">
                            <a-row :gutter="8" :class="isMobile ? 'm-top' : ''">
                              <a-col :xs="24" :lg="14">
                                <li class="m-remove">
                                  <span class="list-title">Tanggal</span>
                                  <span class="list-desc">{{ item.start_time ? moment(item.start_time).format(getDefaultDateFormat) : '-' }}</span>
                                </li>
                                <li class="m-remove">
                                  <span class="list-title">Realisasi Waktu Sistem</span>
                                  <span class="list-desc">{{ moment(item.start_time).format("HH:mm") }} s.d {{ moment(item.end_time).format("HH:mm") }}</span>
                                </li>
                                <li class="m-remove">
                                  <span class="list-title">Realisasi Waktu Manual</span>
                                  <span class="list-desc">{{ moment(item.start_time_usr).format("HH:mm") }} s.d {{ moment(item.end_time_usr).format("HH:mm") }}</span>
                                </li>
                                <li class="m-remove">
                                  <span class="list-title">Realisasi Waktu HRD</span>
                                  <span class="list-desc">
                                    {{ item.start_time_hrd ? moment(item.start_time_hrd).format("HH:mm") : "-" }} s.d {{ item.end_time_hrd ? moment(item.end_time_hrd).format("HH:mm") : "-" }}
                                  </span>
                                </li>
                              </a-col>
                              <a-col :xs="24" :lg="10">
                                <li class="m-remove">
                                  <span class="list-title">TLC Pelaksana</span>
                                  <span class="list-desc">{{ item.pelaksana }}</span>
                                </li>
                                <li class="m-remove">
                                  <span class="list-title">Durasi</span>
                                  <span class="list-desc">{{ realisasijam(item.start_time, item.end_time) }}</span>
                                </li>
                                <li class="m-remove">
                                  <span class="list-title">Durasi</span>
                                  <span class="list-desc">{{ realisasijam(item.start_time_usr, item.end_time_usr) }}</span>
                                </li>
                                <li class="m-remove">
                                  <span class="list-title">Durasi</span>
                                  <span class="list-desc">{{ item.start_time_hrd && item.end_time_hrd ? realisasijam(item.start_time_hrd, item.end_time_hrd) : "-" }}</span>
                                </li>
                                <li class="m-remove">
                                  <span class="list-title">Total Tarif</span>
                                  <span class="list-desc">{{ formatDecimal(item.nilai_tarip) }}</span>
                                </li>
                              </a-col>
                            </a-row>
                            <a-row>
                              <a-col>
                                <li class="m-remove">
                                  <span class="list-title">Catatan</span>
                                  <span class="list-desc">{{ item.catatan }}</span>
                                </li>
                              </a-col>                              
                            </a-row>
                          </a-col>

                          <a-col :xs="24" :lg="9">
                            <a-table
                              :key="'log'+ index"
                              :rowKey="(record, index) => {return index;}"
                              :columns="columnslogHistory"
                              :dataSource="item.log_absen"
                              :pagination="false"
                              :scroll="{ y: 100 }"
                              size="small"
                              bordered
                              :class="isMobile ? 'm-top' : ''"
                            >
                              <template slot="no" slot-scope="value, item, index">
                                {{ (index + 1) }}
                              </template>
                            </a-table>
                          </a-col>

                        </a-row>
                      </td>
                    </tr>
                  </table>
                </ul>
              </a-list-item-meta>
            </a-card>
          </a-list-item>
        </a-list>
      </a-card>
      <template slot="footer">
        <a-button type="primary" @click="modalClose">Oke</a-button>
      </template>
    </a-modal>

    <a-modal
    title="Proses Rekapitulasi Realisasi Tarif Lembur"
      v-model="modalRekapVisible"
      v-if="modalRekapVisible"
    >
      <a-form-model ref="form" :model="formRekap" :rules="rules">
        <a-form-model-item label="Periode" prop="periode">
          <a-month-picker placeholder="Pilih periode" v-model="formRekap.periode" :disabled-date="disabledMonth"/>
        </a-form-model-item>
        <a-form-model-item label="Catatan" prop="note">
          <a-textarea
            placeholder="Ketik catatan disini ... "
            :rows="4"
            v-model="formRekap.note"
          />
        </a-form-model-item>
      </a-form-model>
      <div class="box-bg" style="display: flex; justify-content: space-between; align-items: center;">
        <div>
          <h4 style="margin-bottom:0px"> {{ totalTransaksi }} Transaksi {{ totalPelaksana }} Pelaksana</h4>
        </div>
        <div>
          <a-button type="primary" icon="eye" size="small" @click="showViewDetail"></a-button>
        </div>
      </div>
      <template slot="footer">
        <div>
          <a-button type="secondary" @click="closeModalRekap">Cancel</a-button>
          <a-button type="primary" :loading="loading.process" @click="onSubmitRekap">Proses</a-button>
        </div>
      </template>
    </a-modal>

    <a-modal
    title="View detail transaksi"
    v-model="modalView">
      <a-table
        :rowKey="(record, index) => { return index.toString(); }"
        size="small"
        bordered
        :scroll="{ x: 850 }"
        :columns="columnsView"
        :dataSource="payloadDetail"
        :loading="loading.tab"
        :pagination="pagination"
      >
        <template slot="nomor" slot-scope="text,item,index">{{index+1}}</template>
        <template slot="create_date_and_tlc" slot-scope="item">
          <div style="display: flex; flex-direction: column;">
            <span>{{ dateFormat(item.create_dt) }}</span>
            <span>{{ item.tlc_create }}</span>
          </div>
        </template>
        <template slot="no_realisasi_spl" slot-scope="item">{{ item.no_realisasi_spl }}</template>
        <template slot="divisi" slot-scope="item">{{ item.divisi }}</template>
        <template slot="pelaksana" slot-scope="item">{{ item.pelaksana }}</template>
        <template slot="total_tarif" slot-scope="item">{{ formatDecimal(item.total_tarif) }}</template>
      </a-table>
      <template slot="footer">
        <a-button type="primary" @click="modalView=false">Oke</a-button>
      </template>
    </a-modal>
  </a-spin>
</template>

<script>
import { mapGetters } from "vuex";
import moment from "moment-business-days"
import _ from "lodash";

const columns = [
  {
    title: "#",
    key: "nomor",
    align: "center",
    scopedSlots: { customRender: "nomor" },
    width: 50,
  },
  {
    title: "Create date / TLC",
    key: "create_dt",
    align: "center",
    scopedSlots: { customRender: "create_date_and_tlc" },
    width: 100,
  },
  {
    title: "No. Realisasi SPL",
    key: "no_realisasi_spl",
    align: "center",
    scopedSlots: { customRender: "no_realisasi_spl" },
    width: 210,
  },
  {
    title: "Unit Kerja",
    key: "divisi",
    align: "center",
    scopedSlots: { customRender: "divisi" },
    width: 210,
  },
  {
    title: "Pelaksana",
    key: "pelaksana",
    align: "center",
    scopedSlots: { customRender: "pelaksana" },
    width: 100,
  },
  {
    title: "Nilai Tarif",
    key: "total_tarif",
    align: "center",
    scopedSlots: { customRender: "total_tarif" },
  },
  {
    slots: { title: 'customTitle' },
    key: "aksi1",
    align: "center",
    colSpan: 2,
    fixed: 'right',
    scopedSlots: { customRender: "aksi1" },
    width: 50,
    },
  {
    title: "Aksi",
    key: "aksi2",
    align: "center",
    colSpan: 0,
    fixed: 'right',
    scopedSlots: { customRender: "aksi2" },
    width: 50,
  },
]

const columnsView = [
  {
    title: "#",
    key: "nomor",
    align: "center",
    scopedSlots: { customRender: "nomor" },
    width: 50,
  },
  {
    title: "Create date / TLC",
    key: "create_dt",
    align: "center",
    scopedSlots: { customRender: "create_date_and_tlc" },
    width: 100,
  },
  {
    title: "No. Realisasi SPL",
    key: "no_realisasi_spl",
    align: "center",
    scopedSlots: { customRender: "no_realisasi_spl" },
    width: 210,
  },
  {
    title: "Unit Kerja",
    key: "divisi",
    align: "center",
    scopedSlots: { customRender: "divisi" },
    width: 210,
  },
  {
    title: "Pelaksana",
    key: "pelaksana",
    align: "center",
    scopedSlots: { customRender: "pelaksana" },
    width: 100,
  },
  {
    title: "Nilai Tarif",
    key: "total_tarif",
    align: "center",
    scopedSlots: { customRender: "total_tarif" },
  }
]

const columnslogHistory = [
  {
    title: "#",
    scopedSlots: { customRender: "no" },
    align: "right",
    width: "35px"
  },
  {
    title: "Log. Absensi",
    dataIndex: "timestamp",
    align: "center",
  },
]

const columns_recap = [
  {
    title: "#",
    key: "nomor",
    align: "center",
    scopedSlots: { customRender: "nomor" },
    width: 50,
  },
  {
    title: "No. Rekap",
    key: "no_rekap_tarip",
    align: "center",
    scopedSlots: { customRender: "no_rekap_tarip" },
    width: 200,
  },
  {
    title: "Tanggal",
    key: "create_dt",
    align: "center",
    scopedSlots: { customRender: "create_dt" },
    width: 150,
  },
  {
    title: "TLC Pembuat",
    key: "tlc_create",
    align: "center",
    scopedSlots: { customRender: "tlc_create" },
    width: 100,
  },
  {
    title: "Periode",
    key: "periode",
    align: "center",
    scopedSlots: { customRender: "periode" },
    width: 150,
  },
  {
    title: "Catatan",
    key: "catatan",
    align: "center",
    scopedSlots: { customRender: "catatan" },
  },
  {
    title: "Aksi",
    align: "center",
    scopedSlots: { customRender: "action" },
    width: 100,
  },
]

const rules = {
  periode: {
    required: true,
    message: "Harap isi periode!",
    trigger: ["blur", "change"],
  },
  note: {
    required: true,
    message: "Harap isi catatan!",
    trigger: ["blur", "change"],
  },
}

export default {
  data(){
    return {
      listData: [],
      detailData: [],
      rekapData: [],
      loading: {
        page: false,
        search: false,
        tab: false,
        detail: false,
        process: false,
        submit: false
      },
      moment,
      tabActive: 'list',
      search: '',
      columns,
      columnslogHistory,
      columnsView,
      columns_recap,
      pagination: {},
      checkAll: false,
      selectedItem: [],
      modalVisible: false,
      modalRekapVisible: false,
      modalView: false,
      labelNo: '',
      formRekap: {
        periode: null,
        note: ''
      },
      rules,
      totalPelaksana: 0,
      totalTransaksi: 0,
      payloadDetail: [],
      usedPeriode: []
    }
  },

  computed: {
    ...mapGetters([
      "getAuth",
      "getDefaultDateFormat",
      "getStandartFormatDate",
    ]),
    listDataSearch() {
      let result = null
        result = this.listData
        if (this.search) {
          result = _.filter(this.listData, (e) =>
            e.no_realisasi_spl && e.no_realisasi_spl.toLowerCase().indexOf(this.search.toLowerCase()) >= 0 ||
            e.create_dt && e.create_dt.toLowerCase().indexOf(this.search.toLowerCase()) >= 0 ||
            e.pelaksana && e.pelaksana.toLowerCase().indexOf(this.search.toLowerCase()) >= 0 ||
            e.tlc_create && e.tlc_create.toLowerCase().indexOf(this.search.toLowerCase()) >= 0 ||
            e.divisi && e.divisi.toLowerCase().indexOf(this.search.toLowerCase()) >= 0 || 
            e.total_tarif && e.total_tarif.toLowerCase().indexOf(this.search.toLowerCase()) >= 0
          )
        }
      return result
    },
    listRekap() {
      let result = null
        result = this.rekapData
        if (this.search) {
          result = _.filter(this.rekapData, (e) =>
            e.no_rekap_tarip && e.no_rekap_tarip.toLowerCase().indexOf(this.search.toLowerCase()) >= 0 ||
            e.create_dt && e.create_dt.toLowerCase().indexOf(this.search.toLowerCase()) >= 0 ||
            e.periode_rekap && e.periode_rekap.toLowerCase().indexOf(this.search.toLowerCase()) >= 0 ||
            e.tlc_create && e.tlc_create.toLowerCase().indexOf(this.search.toLowerCase()) >= 0 ||
            e.catatan && e.catatan.toLowerCase().indexOf(this.search.toLowerCase()) >= 0
          )
        }
      return result
    },

    isAllChecked(){
      return this.selectedItem.length == this.listData.length
    },
    isIndeterminate(){
      return this.selectedItem.length > 0 && this.selectedItem.length < this.listData.length
    }
  },

  mounted(){
    this.fetchList()
  },

  watch: {
    tabActive(newVal, oldVal){
      this.selectedItem = []
      if(newVal == 'list'){
        this.fetchList()
      }else {
        this.fetchRecap()
      }
    }
  },

  methods: {
    onChangeSearch(e){

    },

    handleTab(e){
      this.tabActive = e
    },

    async fetchList(){
      this.loading.tab = true
      try {
        const response = await this.asyncAxiosGet('rekap_realisasi_tarif_spl/list', this.getAuth, {});
        this.listData = response.list
        this.usedPeriode = response.periode
        this.loading.tab = false
        
      } catch (error) {
        this.loading.tab = false
        console.log(error);
      }
    },

    async fetchDetail(id, tlc){
      this.loading.detail = true
      try {
        const payload = {
          realisasi_spl_id: id,
          pelaksana: tlc
        }
        const response = await this.asyncAxiosGet('rekap_realisasi_tarif_spl/detail_realisasi', this.getAuth, payload);
        this.detailData = response.list
        this.loading.detail = false
        
      } catch (error) {
        this.loading.detail = false
        console.log(error);
      }
    },

    async fetchRecap(){
      this.loading.tab = true
      try {
        const response = await this.asyncAxiosGet('rekap_realisasi_tarif_spl/list_rekap', this.getAuth, {});
        this.rekapData = response.list
        this.loading.tab = false
        
      } catch (error) {
        this.loading.tab = false
        console.log(error);
      }
    },

    onSelectedItem(e){
      const index = e.target.id
      if (this.selectedItem.includes(index)) {
        this.selectedItem = this.selectedItem.filter(k => k !== index)
      } else {
        this.selectedItem.push(index)
      }
      console.log(this.selectedItem);
    },

    onSelectAll(e){
      const checked = e.target.checked
      this.selectedItem = [] // reset dulu biar aman

      this.listData.forEach(dt => {
        dt.check = checked
        if (checked) this.selectedItem.push(dt.idx)
      })
    },

    dateFormat(date){
      return moment(date).format('DD-MM-YYYY');
    },

    formatDecimal(val) {
      if(Number(val) == 0){
        return 0;
      }else {
        return Number(val).toFixed(4)
      }
    },

    realisasijam(start, end) {
      let result = ""
      start = moment(start)
      end = moment(end)
      let durasi = moment.duration(end.diff(start));
      result = durasi.hours() + " jam " + durasi.minutes() + " menit"
      return result
    },

    showRekapModal(){
      const selectedData = this.listData.filter(dt => this.selectedItem.includes(dt.idx))
      this.payloadDetail = selectedData
      if(selectedData.length > 0){
        this.modalRekapVisible = true
        const uniquePelaksana = [...new Set(selectedData.map(item => item.pelaksana))]
        this.totalPelaksana = uniquePelaksana.length
        this.totalTransaksi = selectedData.length
      }else {
        this.displayMessageValue("error-basic", "Pilih realisasi lembur terlebih dahulu");
      }
    },

    showModalView(data){
      this.modalVisible = true
      this.fetchDetail(data.realisasi_spl_id, data.pelaksana)
      this.labelNo = data.no_realisasi_spl
    },

    modalClose(){
      this.modalVisible = false
    },

    closeModalRekap(){
      this.modalRekapVisible = false
      this.formRekap.periode = null
      this.formRekap.note = ''
    },

    onSubmitRekap(){
      this.loading.process = true
      this.$refs.form.validate( async (valid) => {
        if(!valid){
          this.loading.process = false
          return true
        }

        const payload = {
          detail: this.payloadDetail,
          periode: this.formRekap.periode.format("YYYY-MM-DD HH:mm:ss"),
          note: this.formRekap.note
        }
        try {
          const response = await this.asyncAxiosPost("rekap_realisasi_tarif_spl/create", "json", this.getAuth, payload)
          this.displayMessageValue("success-basic", "Rekap Tarif Lembur berhasil dibuat");
          this.modalRekapVisible = false
          this.loading.process = false
          this.clearForm()
          this.fetchList()
        } catch (error) {
          this.loading.process = false
          console.log(error);
        }
      })
    },

    clearForm(){
      this.selectedItem = []
      this.formRekap.periode = null
      this.formRekap.note = ""
    },

    formatPeriode(val){
      const month = [
        "Januari",
        "Februari",
        "Maret",
        "April",
        "Mei",
        "Juni",
        "Juli",
        "Agustus",
        "September",
        "Oktober",
        "November",
        "Desember"
      ]

      if (!val) return "";

      const [year, monthNum] = val.split("-");
      const namaBulan = month[parseInt(monthNum, 10) - 1];

      return `${namaBulan} ${year}`;
    },

    showManifest(val){
      this.$router.push({ name: "manifest_rekap_realisasi_lembur", params: {id: val.id_rekap_tarip} })
    },

    async deleteData(id){
      try {
        const payload = {
          manifest_id: id
        }
        const response = await this.asyncAxiosDelete('rekap_realisasi_tarif_spl/remove_rekap', "json", this.getAuth, payload)
        this.displayMessageValue("success-basic", "Success delete data");
        this.fetchRecap()
      } catch (error) {
        console.log(error);
      }
    },

    showConfirm(val){
      this.$confirm({
        title: 'Apakah anda yakin ingin menghapus ?',
        content: `${val.no_rekap_tarip}`,
        okText: 'Oke',
        cancelText: 'Cancel',
        onOk: () => {
          this.deleteData(val.id_rekap_tarip)
        }
      })
    },

    showViewDetail(){
      this.modalView = true
    },

    disabledMonth(current){
      if (!current) return false;
      const year = current.year();
      const month = (current.month() + 1).toString().padStart(2, "0");
      const periode = `${year}-${month}`;

      // disable kalau periode udah ada di DB
      return this.usedPeriode.includes(periode);
    },

  }
}

</script>

<style>
  .box-bg{
    background: #80808063;
    padding: 10px;
    border-radius: 3px;
  }

  .textsearch{
    margin-bottom : 16px!important;
  }

  .action-section {
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    gap: 10px;
  }
</style>